export default __webpack_public_path__ + "static/media/Artboard 1.c83d18ca.jpg";